// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"Desktop_swiper-slide-active__L5qNm","wrapper":"Desktop_wrapper__qcRpT"};